module.exports = __webpack_public_path__ + "static/media/background.57638209.png";